import { REDUCER } from './reducersConst';
import { GROUPS } from '../const';
import { MODES } from '../components/drawer-contents/AssignmentsContentPanel/assignmentsContentPanelService';
import dayjs from 'dayjs';

let initialState = {
  startDate: dayjs(),
  dueDate: dayjs().add(3, 'days'),
  selectedGroup: JSON.parse(JSON.stringify(GROUPS.EVERYONE)),
  description: '',
  mode: MODES.READ,
  discussionId: undefined,
  title: ''
};

export let discussionsDrawer = (state = initialState, action) => {
  switch (action.type) {
    case REDUCER.DISCUSSION_DRAWER.SET_TITLE:
      return {
        ...state,
        title: action.title
      };
    case REDUCER.DISCUSSION_DRAWER.SET_DESCRIPTION:
      return {
        ...state,
        description: action.description
      };
    case REDUCER.DISCUSSION_DRAWER.SET_SELECTED_GROUP:
      return {
        ...state,
        selectedGroup: action.selectedGroup
      };
    case REDUCER.DISCUSSION_DRAWER.SET_START_DATE:
      return {
        ...state,
        startDate: action.startDate
      };
    case REDUCER.DISCUSSION_DRAWER.SET_DEAD_LINE:
      return {
        ...state,
        dueDate: action.dueDate
      };
    case REDUCER.DISCUSSION_DRAWER.SET_MODE:
      return {
        ...state,
        mode: action.mode
      };
    case REDUCER.DISCUSSION_DRAWER.SET_DISCUSSION_ID:
      return {
        ...state,
        discussionId: action.discussionId
      };
    default:
      return state;
  }
};
